import React from "react";
import { Switch, Route } from "react-router-dom";
import { ProjectProvider } from "../Contexts/projet";
import { useUser } from "../Contexts/user";
import Agence from "../Views/Task/Agence";
import Auth from "../Views/Task/Auth";
import Client from "../Views/Task/Client";
import Dashboard from "./Dashboard";

function Router() {
  const { token } = useUser();
  return (
    <div>
      <ProjectProvider>
          {token ? (
            <Switch>
              <Route path="/agence">
                <Dashboard>
                  <Agence />
                </Dashboard>
              </Route>
              <Route path="/client">
                <Dashboard>
                  <Client />
                </Dashboard>
              </Route>
              </Switch>
          ) : (
            <Switch>
              <Auth/>
            </Switch>
          )}
        
      </ProjectProvider>
    </div>
  );
}

export default Router;
